<template>
  <div class="card container-fluid" style="width: 500px;">
    <div class="row">
      <div class="col">
        <!-- Normal title mini -->
        <h6 class="title_login">Crear una cuenta con OAuth by Medisoft</h6>
        <hr class="hr">
        <!-- Image of product section -->
        <div style="text-align: center">
          <img class="product_legal shadow-sm" :src="`data:${data.devApp.iconoExt};base64,${data.devApp.icono}`"> <!-- :src="`data:${data.devApp.iconoExt};base64,${data.devApp.icono}`" alt="" -->
        </div>
        <!-- Formulario de inicio de sesion -->
        <Form ref="Form">
          <Input inline prop="identification" label="Identificacion" type="text" v-model="form.identification"/>
          <Input inline prop="names" label="Nombres" type="text" v-model="form.names"/>
          <Input inline prop="surnames" label="Apellidos" type="text" v-model="form.surnames"/>
          <Input inline prop="email" label="Email" type="email" v-model="form.email"/>
          <Input inline prop="password1" label="Contraseña" type="password" v-model="form.password1"/>
          <Input inline prop="password2" label="Confirme contraseña" type="password" v-model="form.password2"/>
          <Input inline prop="movil" label="Numero Celular" type="text" v-model="form.movil"/>
          <div class="buttons_container">
<!--            <button class="btn btn-light btn-sm" @click.prevent="submitChange">Recuperar contraseña</button>-->
            <button class="btn btn-primary btn-sm" @click.prevent="submitDialog">Crear cuenta y continuar</button>
          </div>
        </Form>
        <!-- Informacion legal -->
        <p style="text-align: left; font-size: 12px; margin-top: 18px; opacity: 0.7;">
          <span>
            {{ `Para continuar, OAuth compartirá tu nombre, tu dirección de correo electrónico y tu foto de perfil con
            ${data.devApp.nombre}. Antes de usar esta aplicación, puedes leer la politica de privacidad y los terminos de servicio cuyos links estan debajo.` }}
          </span>
        </p>
        <hr>
        <!-- Accesos legales -->
        <div class="buttons_legal">
          <button type="button" class="btn btn-link btn-sm" @click.prevent="goto('/download', true)">Descargar administrador</button>
          <button type="button" class="btn btn-link btn-sm" @click.prevent="goto('https://www.faelectronica.com/docs/privacity.pdf', false)">Privacidad</button>
          <button type="button" class="btn btn-link btn-sm" @click.prevent="goto('https://www.faelectronica.com/docs/terms.pdf', false)">Terminos</button>
        </div>
      </div>
    </div>
    <Loading v-if="state === 'load'" :text="action"/>
  </div>
</template>

<script>
import Form from '@/components/elements/Form'
import Input from '@/components/elements/Input'
import Loading from './elements/Loader'
export default {
  name: 'CreateComponent',
  components: {
    Form,
    Input,
    Loading
  },
  props: {
    data: null
  },
  data () {
    return {
      state: 'idle',
      action: 'Verificando cookies',
      rules: [
        { prop: 'identification', type: 'empty', message: 'El numero de su identificacion es requerido' },
        { prop: 'names', type: 'empty', message: 'Debe al menos darnos un nombre' },
        { prop: 'surnames', type: 'empty', message: 'Debe al menos darnos un apellido' },
        { prop: 'email', type: 'empty', message: 'Debe especificar un correo electronico' },
        { prop: 'email', type: 'email', message: 'El valor especificado no coincide con una direccion de correo' },
        { prop: 'password1', type: 'empty', message: 'Debe darnos una contraseña' },
        { prop: 'password2', type: 'empty', message: 'Debe confirmar su contraseña' },
        { prop: 'password2', type: 'equal', equal: 'password1', message: 'Debe confirmar su contraseña' },
        { prop: 'movil', type: 'empty', message: 'Debe darnos al menos un telefono movil' }
      ],
      form: {
        identification: '',
        names: '',
        surnames: '',
        email: '',
        password1: '',
        password2: '',
        movil: '',
        born: ''
      }
    }
  },
  methods: {
    submitDialog () {
      // reestablecer el formulario
      this.$refs.Form.clear()
      // ejecutar pruebas
      const result = this.$refs.Form.validate(this.rules)
      // ejecutamos la operacion
      if (result) {
        this.state = 'load'
        this.$oauthcore.api.Profile.CreateProfile(this.data.public, {
          identificacion: this.form.identification,
          nombres: this.form.names,
          apellidos: this.form.surnames,
          email: this.form.email,
          password1: this.form.password1,
          passwordConfirm: this.form.password2,
          fechaNacimiento: new Date(),
          country: '+57',
          numeroMovil: this.form.movil,
          os: '',
          navegador: ''
        }).then((rta) => {
          this.$oauthcore.cookie.CreateCookies(this.data.public, rta.result.sesion) // Crea una sesion en las cookies
          this.state = 'idle'
          this.urlReturn = this.data.devApp.urlOK.replace('#{useridentifier}#', rta.result.userid).replace('#{sesionidentifier}#', rta.result.sesion)
          window.location.replace(this.urlReturn)
        }).catch((err) => {
          console.log(err)
          let message = ''
          if (err.code === 404) message = `El dato ${err.exception.Message.split('\'')[1]} ya ha sido utilizado por otro usuario.`
          else message = err.help
          this.state = 'idle'
          this.urlReturn = this.data.devApp.urlError.replace('#{error-code}#', err.code)
          alert(message)
        })
      }
    }
  }
}
</script>

<style lang="scss">
.card {
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  padding: 10px;
}
.hr_login {
  margin: 5px 0 15px 0;
}
.title_login {
  opacity: 0.6;
  font-size: 14px;
}
.buttons_container {
  margin-top: 5px;
  text-align: right;
  * {
    margin-left: 10px;
    font-weight: 600!important;
  }
}
.buttons_legal {
  text-align: center;
  * {
    font-size: 12px!important;
  }
}
.product_legal {
  height: 80px;
  padding: 8px;
  margin-bottom: 15px;
}
</style>
